import privateAxios from "../utils/axiosPrivate";
import { getCheckBackendAccessURL } from "../utils/constants/apiEndPoints";

const useBackendAccessApi = () => {
  const IsBackendPermission = async () => {
    const response = await privateAxios.post(getCheckBackendAccessURL);
    return response;
  };
  return { IsBackendPermission };
};

export default useBackendAccessApi;
